import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=8151e970&scoped=true&"
import script from "./TheHeader.vue?vue&type=script&lang=ts&"
export * from "./TheHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=8151e970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8151e970",
  null
  
)

export default component.exports